import { getRowKey } from '../';
import { PardotFormRow } from './PardotFormRow';
import { PardotFormSearch } from './PardotFormSearch';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SearchFilterQueryParams } from '../filters';
import { SelectionTable } from '@ui/tables';
import { KeyPagination, keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import {
	KeyPaginationQueryParams,
	OffsetPaginatedResource,
	PeriscopePardotForm,
	SonarObjectType
} from '@sonar-software/sonar-ts-types';
import React, { useCallback, useRef } from 'react';
import { useQueryResource, useSelectionTable } from '@hooks';

type Resource = OffsetPaginatedResource<PeriscopePardotForm>;
export type PardotFormSearchableSelectionTableV3QueryParams = KeyPaginationQueryParams & SearchFilterQueryParams;

export interface PardotFormSearchableSelectionTableV3Props {
	parentIndex: number;
	resourceIdsUri: string;
	uri: string;
}

export const PardotFormSearchableSelectionTableV3: React.FC<PardotFormSearchableSelectionTableV3Props> = ({
	parentIndex,
	resourceIdsUri,
	uri
}) => {
	const scrollableListRef = useRef<HTMLDivElement>(null);

	const { loading, resource, queryParams, updateParams } = useQueryResource<
		Resource,
		PardotFormSearchableSelectionTableV3QueryParams
	>({
		defaultParams: keyPaginationDefaultQueryParams,
		fallbackParams: keyPaginationFallbackQueryParams,
		uri
	});

	const selectionData = useSelectionTable({
		getRowKey,
		queryParams,
		resourceIdsUri,
		results: resource?.results,
		selectionType: SonarObjectType.PardotForm
	});

	const renderForm = useCallback(
		(record: PeriscopePardotForm) =>
			<PardotFormRow
				key={ record.sonarObjectId }
				parentIndex={ parentIndex }
				record={ record } />
		,
		[ parentIndex ]
	);

	const results = resource?.results;

	return (
		<>
			<PardotFormSearch onChange={ updateParams } />
			<SelectionTable
				dataSource={ results }
				loading={ loading }
				ref={ scrollableListRef }
				renderRow={ renderForm }
				rowKey={ getRowKey }
				selectionData={ selectionData }
				selectionType={ PERISCOPE_TAB_TYPES.PARDOT_FORMS } />
			<KeyPagination
				defaultPageSize={ Number(queryParams.count) }
				listRef={ scrollableListRef }
				onChange={ updateParams }
				resource={ resource } />
		</>
	);
};
